import { Modal, Col, Row, Space, Typography, Button, message } from "antd";
import { useState } from "react";
import WellbeingMaterialEngagementView from "../components/wellbeing-corner/WellbeingMaterialEngagementView";
import MaterialCoverageView from "../components/wellbeing-corner/MaterialCoverageView";
import { SearchQuery } from "../code/search-query/search-query";
import { getMaterialEngagementExport } from "../repository/data.repository";
import Loader from "../controls/Loader";
import { getProblemMessage } from "../utils/http";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";

function WellbeingMaterialEngagementPage() {
  const permissions = useSelector(authorizeSelectors.permissions);
  const [modal, contextHolder] = Modal.useModal();
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({
    conditions: [],
  });
  const [coverageOpen, setCoverageOpen] = useState(false);

  function onSearch(searchQuery: SearchQuery): void {
    setSearchQuery(searchQuery);
  }

  function onDownloadExport(): void {
    const loading = modal.info({
      content: (
        <Typography.Text className="m-1 ml-2 inline-block">
          Downloading engagement export file..
        </Typography.Text>
      ),
      footer: null,
      centered: true,
      icon: <Loader />,
    });
    getMaterialEngagementExport({
      searchQuery,
      pageNumber: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
    })
      .then(() => loading.destroy())
      .catch((err) => {
        loading.destroy();
        message.error(getProblemMessage(err) || "Failed to download export.");
      });
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Engagement
        </Typography.Title>
        <Space className="flex flex-row">
          <Button onClick={() => setCoverageOpen(true)}>Coverage</Button>
          <Button
            type="primary"
            disabled={!permissions.can("WellbeingCornerEngagement", "view")}
            onClick={onDownloadExport}
          >
            Export to Excel
          </Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <WellbeingMaterialEngagementView onSearch={onSearch} />
      </Col>
      <Modal
        open={coverageOpen}
        title="Engagement Coverage"
        footer={null}
        width={920}
        destroyOnClose
        onCancel={() => setCoverageOpen(false)}
      >
        <MaterialCoverageView />
      </Modal>
      {contextHolder}
    </Col>
  );
}

export default WellbeingMaterialEngagementPage;
